import React, { Fragment, useContext, useEffect } from "react";
import { Box, Grid, Paper } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Logo from "../../Logo/Logo";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import { useWelcomeMessageStyle } from "../hooks/useWelcomeMessageStyle";

export default function AppStartMessage({
  textId,
  hidingMessage,
  showStartButton,
  startToHideMessage,
}) {
  const {
    state: { appStarted },
    dispatch,
  } = useContext(ProcessContext);
  const { circleLogoHeight, circleLogoWidth } = useWelcomeMessageStyle();

  const startApp = () => {
    dispatch({
      type: "START_APP",
    });
    if (startToHideMessage) startToHideMessage();
  };

  useEffect(() => {
    if (!appStarted && hidingMessage) {
      startApp();
    }
  }, [appStarted, hidingMessage]);

  return (
    <Fragment>
      <Box
        zIndex={"modal"}
        className={hidingMessage ? "disappear-anim" : ""}
        width={"100%"}
        height={"100%"}
        left={0}
        top={0}
        position={"absolute"}
        display={"flex"}
        style={{ pointerEvents: hidingMessage ? "none" : "inherit" }}
      >
        <Paper elevation={0} className={"w-100 text-center"}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            className={"h-100"}
          >
            <Grid item>
              <Typography color={"primary"} variant={"h6"} className={"mb-3"}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent={"center"}
                  className={"circle-border-appear-anim"}
                  style={{
                    borderRadius: "100px",
                    height: `${circleLogoHeight}px`,
                    width: `${circleLogoWidth}px`,
                  }}
                >
                  <Logo height={circleLogoHeight} width={circleLogoWidth} />
                </Box>
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Fragment>
  );
}
